app.controller('visitCreateController', ['$rootScope', '$scope', '$state', '$stateParams', '$mdDialog', 'objectHelper', 'baseModel', 'applicationModel', 'visitModel', 'userModel', 'doctorModel',
    function ($rootScope, $scope, $state, $stateParams, $mdDialog, objectHelper, baseModel, applicationModel, visitModel, userModel, doctorModel) {

        function setData() {
            $scope.forms = {
                visitForm: null
            };

            $scope.visit = new VisitVO();
            $scope.visit.doctor = new DoctorVO();
            $scope.visit.doctor.id = userModel.getCurrentContextDoctorId();

            $scope.visit.clinic = new ClinicVO(1); // fixme - it's hardcoded for now

            $scope.visitTypes = Object.keys(Enum.VISIT_TYPE);

            $scope.visit.date = new Date();
            $scope.visit.date.setHours($scope.visit.date.getHours()+2, 0, 0, 0);

            $scope.now = new Date();
        }

        function setPermissions() {
        }

        function setListeners() {
            var disabler = $scope.$watch('patient', function (newVal) {
                $scope.visit.patient = newVal;
                disabler();
            });

            $scope.$on(Event.DOCTOR.GET_BY_ID.SUCCESS, function(event, data) {
                $scope.visit.clinic = data.individualPractice;
            })

        }

        function setActions() {
            $scope.save = function () {
                $scope.forms.visitForm.$setSubmitted();
                if($scope.forms.visitForm.$valid) {
                    visitModel.save($scope.visit);
                    var successDisabler = $scope.$on(Event.VISIT.SAVE.SUCCESS, function (event, visit) {
                        $scope.goBack();
                        successDisabler();
                        errorDisabler();
                    });
                    var errorDisabler = $scope.$on(Event.VISIT.SAVE.ERROR, function (event, visit) {
                        successDisabler();
                        errorDisabler();
                    });
                }
            };

            $scope.goBack = function () {
                $scope.$parent.goBack(Constant.STATE.APP.HOME);
            };

            $scope.addNewPatient = function() {
                $mdDialog.show({
                    templateUrl: 'edm/application/view/app/visit/popup/popup-visit-create-patient.html',
                    controller: 'popupVisitCreatePatientController'
                }).then(function () {

                }, function () {

                });
            }
        }

        function configureInterface() {
        }

        function initialize() {
            doctorModel.getById(userModel.getCurrentContextDoctorId());
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
